import React from 'react';

interface BrandLogoProps {
  className?: string;
  width?: number;
  height?: number;
}

/**
 * Brand logo SVG component for fallback image display
 */
export const BrandLogo: React.FC<BrandLogoProps> = ({
  className = '',
  width = 80,
  height = 80,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="120" height="120" fill="var(--bg-secondary, #F5F5F5)" />
      <path
        d="M60 30C46.745 30 36 40.745 36 54V66C36 79.255 46.745 90 60 90C73.255 90 84 79.255 84 66V54C84 40.745 73.255 30 60 30Z"
        fill="var(--text-tertiary, #999999)"
      />
      <path d="M50 50H70V55H50V50Z" fill="var(--bg-primary, #FFFFFF)" />
      <path d="M50 60H70V65H50V60Z" fill="var(--bg-primary, #FFFFFF)" />
      <path d="M50 70H65V75H50V70Z" fill="var(--bg-primary, #FFFFFF)" />
    </svg>
  );
};

export default BrandLogo;
